<template>
  <div ref="typefilter" class="type-filter">
    <div class="filter-wrapper" :class="activeFilter ? 'open-filter' : ''" @click="toggleFilter()">
      <div class="filter-container">
        <div class="filter-option" :class="filterApplied && 'bold-effect'">
          {{ filterApplied ? type === 'language' ? $t('lang_' + filterApplied.label) : (filterApplied.label ? $t(filterApplied.label) : $t('all_types')) : $t('all_types') }}
        </div>
        <div class="icon-chevron" />
      </div>
    </div>
    <div class="filter-options-wrapper" :class="activeFilter ? 'lateral-filter-grow' : 'filter-hidden'">
      <div
        v-if="type !== 'language'"
        class="filter-theme"
        :class="!filterApplied ? 'selected-value' : ''"
        @click="PBDFilterChange(null)"
      >
        <div v-if="!filterApplied" class="icon-check" />
        <div class="filter-theme-option">{{ $t('all_types') }}</div>
      </div>
      <div
        v-for="filter in filterOptions"
        :key="filter.label"
        class="filter-theme"
        :class="(filterApplied && filterApplied.label === filter.key) ? 'selected-value' : ''"
        @click="PBDFilterChange(filter)"
      >
        <div :class="(filterApplied && filterApplied.label === filter.key) ? 'icon-check' : ''" />
        <div class="filter-theme-option">{{ filter.label }}</div>
      </div>
    </div>
  </div>
</template>
  
<script>
import { t } from '../../i18n'

export default {
	components: { },
  props: {
    type: {
      type: String,
    },
  },
	data() {
		return {
      activeFilter: false,
		}
	},
	computed: {
    filterApplied() {
      let labelSting = null
      if (this.type === 'type') {
        if (this.$route.query && this.$route.query.typeFil) {
          labelSting = this.$route.query.typeFil
        }
      } else if (this.type === 'down-type') {
        if (this.$route.query && this.$route.query.downTypeFil) {
          labelSting = this.$route.query.downTypeFil
        }
      } else if (this.type === 'language') {
        if (this.$route.query && this.$route.query.langFil) {
          labelSting = this.$route.query.langFil
        }
        else {
          labelSting = 'ca'
        }
      }
      if (labelSting) {
        return {
          label: labelSting,
        }
      }
      return false
    },
    filterOptions() {
      let ops = []
      if (this.type === 'type') {
        let options = ['STATISTICS', 'MICRODATA', 'DATASTORIES', 'SURVEY', 'DOCS', 'MAPS']
        options.forEach(op => {
          ops.push({
            label: t(op),
            key: op,
          })
        })
      } else if (this.type === 'down-type') {
        let options = ['STATISTICS', 'MICRODATA', 'SURVEY', 'DOCS', 'MAPS']
        options.forEach(op => {
          ops.push({
            label: t(op),
            key: op,
          })
        })
      } else if (this.type === 'language') {
        let options = [{key: 'ca', label: 'lang_ca'}, {key: 'es', label: 'lang_es'}, {key: 'en', label: 'lang_en'}]
        options.forEach(op => {
          ops.push({
            key: op.key,
            label: t(op.label)
          })
        })
      }
      return ops
    }
	},
	methods: {
    toggleFilter() {
      this.activeFilter = !this.activeFilter
    },
    PBDFilterChange(fil) {
      let currentQuery = {...this.$route.query}
      if (fil) {
        if (this.type === 'type') {
          currentQuery.typeFil = fil.key
        } else if (this.type === 'down-type') {
          currentQuery.downTypeFil = fil.key
        } else if (this.type === 'language') {
          currentQuery.langFil = fil.key
        }
      }
      else {
        if (this.type === 'type') {
          delete currentQuery.typeFil
        } else if (this.type === 'down-type') {
          delete currentQuery.downTypeFil
        } else if (this.type === 'language') {
          delete currentQuery.langFil
        }
      }

      //GRJ2EE-9006_select_estadisticas
      this.activeFilter = false
      
      let element = this.$refs['typefilter'].parentElement.parentElement.parentElement
      let header = document.getElementById('header')?.offsetHeight || 0
      let top = element.offsetTop - header - (header !== 0 ? 45 : 10)
      this.$router.push({
        name: this.$route.name,
				query: currentQuery,
      }).then(() => {
        window.scrollTo(0, top)
      })
    },
	},
}
</script>

<style lang="stylus" scoped>
.type-filter
  display: flex
  align-items: center
  position: relative
  margin-right: vw(5px)
  
  .filter-options-wrapper
    position: absolute
    top: 100%
    right: 0
    width: 100%
    padding: vw(10px)
    border: 1px solid $grey-grey
    border-radius: 8px
    background-color: #fff
    z-index: 2

    // box-shadow: 0 4px 10px rgba(105, 105, 115, 0.2)
    .filter-theme
      display: flex
      align-items: center
      padding: vw(6px) vw(8px) vw(6px) vw(32px)
      border-radius: 6px
      
      &:not(:last-child)
        margin-bottom: vw(5px)

      &:hover
        // &:not(.selected-value)
        background-color: $corpotative-color-very-light
        cursor: pointer

      &.selected-value
        background-color: $corpotative-color-very-light
        cursor: default

        .filter-theme-option
          color: $corporate_color
          font-weight: 600

      .icon-check
        m-icon("check", 16, $corporate_color)
        margin-right: vw(5px)
        margin-left: vw(-20px)

    .filter-theme-option
      m-font-size(14, 18)
      margin-top: 0.1em
        
  .filter-hidden
    display: none

  .lateral-filter-grow
    transform-origin: top center
    animation: growDown 0.25s ease-in-out forwards
    z-index: 3

  .filter-wrapper
    min-width: vw(200px)
    
    &.open-filter
      position: relative

      &:before
        position: absolute
        top: vw(-4px)
        left: vw(-4px)
        width: "calc(100% + %s)" % vw(8px)
        height: "calc(100% + %s)" % vw(8px)
        border-radius: 4px
        background-color: $light-grey
        content: ""

      .icon-chevron
        transform: rotate(180deg)

    .icon-chevron
      m-icon("chevron-down", 24)
      transition: transform 0.25s ease-in-out
      transform-origin: 50% 55%
      
  .filter-container
    position: relative
    display: flex
    justify-content: space-between
    align-items: center
    padding: vw(5px) vw(10px)
    width: 100%
    border: 1px solid $grey
    border-radius: 4px
    background-color: #fff
    cursor: pointer

    .filter-option
      m-font-size(16, 26)
      color: $grey
      color: #000

      &.bold-effect
        font-weight: 600
        
@keyframes growDown
  0%
    transform: scaleY(0)

  100%
    transform: scaleY(1)
    
</style>
